

import React from "react";
import { Layout, Dropdown, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useAppContext } from '../context/AppContext';
import { getCurrentVillageName } from '../config/villageConfig';
import "./HeaderBar.css";

const { Header } = Layout;

// Navigation links configuration
const NAV_LINKS = [
  { key: '/', name: 'मुख्यपृष्ठ', href: '/' },
  { key: '/gram-panchayat', name: 'आमची ग्राम पंचायत', href: '/gram-panchayat' },
  { key: '/our-village', name: 'आमचे गाव', href: '/our-village' },
  { key: '/schemes-projects', name: 'योजना आणि प्रकल्प', href: '/schemes-projects' },
  { key: '/citizen-services', name: 'नागरिक सेवा', href: '/citizen-services' },
  { key: '/transparency-reports', name: 'गावाचा अर्थसंकल्प', href: '/transparency-reports' },
  { key: '/photo-gallery', name: 'फोटो गॅलरी', href: '/photo-gallery' },
  { key: '/digital-library', name: 'डिजिटल ग्रंथालय', href: '/digital-library' },
  { key: '/donation', name: 'देणगी', href: '/donation' },
  { key: '/ceremony', name: 'समारंभ', href: '/ceremony' },
  { key: '/birthday-wishes', name: 'आपल्या गावचा कट्टा', href: '/birthday-wishes' },
  { key: '/rti', name: 'माहितीचा अधिकार', href: '/rti' },
  { key: '/samruddha-panchayat', name: 'मुख्यमंत्री समृद्ध पंचायत राज अभियान', href: '/samruddha-panchayat' },
];

const HeaderBar = ({ navProps }) => {
  // Prefer AppContext actions when props not provided
  const ctx = useAppContext(); // safe: returns null when provider missing
  const state = ctx?.state;

  const menu = (
    <Menu
      items={[
        { key: "1", label: <a href="#main-content">Jump to Content</a> },
        { key: "2", label: <a href="https://india.gov.in" target="_blank" rel="noreferrer">Visit India.gov.in</a> },
      ]}
    />
  );

  return (
    <>
      <Header className="top-header">
        <div className="headerbar-inner-container">
          <div className="header-left">
            <img loading="lazy" src="https://flagcdn.com/w20/in.png" alt="India Flag" className="flag-icon" />
            <a href="https://india.gov.in" target="_blank" rel="noopener noreferrer" className="gov-link">
              Government of India
            </a>
          </div>
          <div className="header-right">
            <a href="#main-content" className="skip-link">
              Skip to Main Content
            </a>
            <div className="accessibility-icons">
              {/* <button className="font-btn" aria-label="Decrease Font Size" onClick={handleDecrease}>A</button>
              <button className="font-btn font-btn-large" aria-label="Increase Font Size" onClick={handleIncrease}>A+</button>
              <Switch checked={currentDark} onChange={handleToggleDark} size="small" title="Toggle Dark Mode" />
                */}
              {/* {navProps?.Select && (
                <navProps.Select
                  defaultValue={navProps.i18n?.language || (state?.language || 'mr')}
                  style={{ width: 110, height: 24, zIndex: 2000 }}
                  onChange={(val) => {
                    // notify parent handler first if present
                    if (typeof navProps.changeLang === 'function') navProps.changeLang(val);
                    if (dispatch) dispatch({ type: 'SET_LANGUAGE', payload: val });
                  }}
                  aria-label="language-select"
                  className="header-language-select"
                >
                  <navProps.Select.Option value="mr">मराठी</navProps.Select.Option>
                  <navProps.Select.Option value="en">English</navProps.Select.Option>
                </navProps.Select>
              )} */}
              <Dropdown overlay={menu} placement="bottomRight">
                <MoreOutlined style={{ cursor: "pointer", fontSize: 18, color: '#fff' }} />
              </Dropdown>
            </div>
          </div>
        </div>
      </Header>
      {/* Navigation/Logo/Language Section */}
      {navProps && (
        <div style={{ width: '100%', background: '#FFFFFF' }}>
          <div className="header-container">
            <div className="headerbar-inner-container">
              <nav style={{ width: '100%', display: 'flex', alignItems: 'center', height: 72, gap: 12 }}>
                <div style={navProps.leftStyle}>
                  <img loading="lazy" src={navProps.emblem} alt="National Emblem" style={navProps.logoStyle} />
                  <div
                    style={{
                      height: navProps.logoStyle?.height || 38,
                      width: navProps.logoStyle?.height || 38,
                      display: 'block',
                      backgroundColor: 'var(--color-primary)',
                      WebkitMaskImage: `url(${navProps.logo})`,
                      WebkitMaskSize: 'contain',
                      WebkitMaskRepeat: 'no-repeat',
                      WebkitMaskPosition: 'center',
                      maskImage: `url(${navProps.logo})`,
                      maskSize: 'contain',
                      maskRepeat: 'no-repeat',
                      maskPosition: 'center'
                    }}
                    className="village-logo"
                    role="img"
                    aria-label="Village Logo"
                  />
                  <h2 style={{
                    borderRadius: "8px",
                    fontFamily: "Teko",
                    fontWeight: 500,
                    fontSize: 'clamp(16px, 5vw, 24px)',
                    margin: 0,
                    marginBottom: 0,
                    color: 'var(--color-primary)',
                  }}>
                    {navProps.i18n.t('ग्रामपंचायत')} {getCurrentVillageName(navProps.i18n?.language || state?.language || 'mr')}
                  </h2>
                </div>
                <div style={navProps.menuWrapperStyle}>
                  {!navProps.isMobile ? (
                    <navProps.Menu mode="horizontal" selectedKeys={[navProps.selectedKey]} style={navProps.menuStyle}>
                      {NAV_LINKS.slice(0, 6).map((link) => (
                        <navProps.Menu.Item key={link.key}>
                          <navProps.Link to={link.href}>{link.name}</navProps.Link>
                        </navProps.Menu.Item>
                      ))}
                      {NAV_LINKS.length > 6 && (
                        <navProps.Menu.SubMenu
                          key="more-menu"
                          title={<img loading="lazy" src={navProps.menuIcon} alt="More" style={{ width: 36, height: 36 }} />}
                        >
                          {NAV_LINKS.slice(6).map((link) => (
                            <navProps.Menu.Item key={link.key}>
                              <navProps.Link to={link.href}>{link.name}</navProps.Link>
                            </navProps.Menu.Item>
                          ))}
                        </navProps.Menu.SubMenu>
                      )}
                    </navProps.Menu>
                  ) : null}
                </div>
                <div style={navProps.rightStyle}>
                  <img loading="lazy" src={navProps.searchIcon} alt="Search" style={{ width: 36, height: 36 }} />
                  {navProps.isMobile && (
                    <button
                      onClick={() => navProps.setDrawerOpen(true)}
                      aria-label="open-menu"
                      style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 24, marginLeft: '-4px' }}
                    >
                      <img loading="lazy" src={navProps.menuIcon} alt="Menu" style={{ width: 36, height: 36 }} />
                    </button>
                  )}
                </div>
              </nav>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderBar;
